import React, { useState } from "react"
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai'

export default function Header() {
    const [toggle, setToggle] = useState(false);
    return (


        <div className=' p-6 p-6 bg-transparent text-black-700 font-semibold py-2 px-16 border-transparent rounded  shadow-2xl shadow-blue-500/50  '>
            <div className='max-w-100% py-[10px] items-center flex justify-between border-black mx-auto'>
                <div className='flex text-3xl font-bold'>
                    Vaccination Slots
                </div>
                {
                    toggle ?
                        <AiOutlineClose onClick={() => setToggle
                            (!toggle)} className=' text-2xl md:hidden' />
                        :
                        <AiOutlineMenu onClick={() => setToggle
                            (!toggle)} className=' text-2xl md:hidden' />
                }

                <ul className='hidden md:flex text-black font-bold gap-20 '>
                    <li>
                        Dashboard
                    </li>
                    <li>
                        ABHA
                    </li>
                    <li>
                    Partners
                    </li>
                    <li>
                        FAQ's
                    </li>
                    <li className="bg-transparent hover:bg-orange-500 text-black-700 font-bold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                        REGISTER/SIGN IN
                    </li>
                </ul>

                <ul className={` duration-300 md:hidden w-full h-screen text-white fixed bg-black top-[92px]
                    ${toggle ? 'right-[0]' : 'right-[-100%]'} 
                        `}>
                    <li className="p-5">
                    Dashboard
                    </li>
                    <li className="p-5">
                    ABHA
                    </li>
                    <li className="p-5">
                    Partners

                    </li >
                    <li className="p-5">
                    FAQ's
                    </li>
                    <li className="p-5 bg-transparent text-black-700 font-bold hover:text-white py-2 px-4 ">
                    REGISTER/SIGN IN
                    </li>
                </ul>

            </div>

        </div >
    )
}




